// extracted by mini-css-extract-plugin
export default {"Player":"Player_Player__JyQl6","num":"Player_num__dTboV"};